import React from "react";
import submit from "../../assets/images/resource/submit.svg";
import NextBtn from "./nextbutton";

const Submit = ({ handleStepChange }) => {
  return (
    <div className='resource-step-content'>
      <div className='resource-content'>
        <div className='resource-step-heading submit-heading'>
          <img src={submit} alt='submit' />
          <h4>Submit your proposal</h4>
          <p>
            Please review all the information you previously typed in the past
            steps, and if all is okay, submit your message to receive a project
            quote in 24 - 48 hours.
          </p>
        </div>
        <NextBtn handleStepChange={handleStepChange} type='NoMoreSteps' />
      </div>
    </div>
  );
};

export default Submit;
